// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

import LoginPage from '@/components/LoginPage.vue';
import MainPage from '@/components/mainPage.vue';
import AlimentacionSinSoporte from '@/components/alimentacionSinSoporte.vue';
import TransporteSinSoporte from '@/components/transporteSinSoporte.vue';
import ExpenseForm from '@/components/ExpenseForm.vue';
import maestroViajes from '@/components/maestroViajes.vue'
import autorizarGastos from '@/components/autorizarGastos.vue'
import accountSpent from '@/components/accountSpent.vue'
import updateTables from '@/components/updateTables.vue'

const routes = [
  { path: '/LoginPage', name: 'LoginPage', component: LoginPage },
  {path: '/', component: MainPage, name: 'MainPage', children: [
    { path: '/maestroGastos', name: 'maestroGastos', component: maestroViajes },
    { path: '/detallesGastos', name: 'detalleGastos', component: ExpenseForm },
    { path: '/detalleAlimentacionSS', name: 'detalleAlimentacionSS', component: AlimentacionSinSoporte },
    { path: '/detalleTransporteSS', name: 'detalleTransporteSS', component: TransporteSinSoporte },
    { path: '/autorizarGastos', name: 'autorizarGastos', component: autorizarGastos },
    { path: '/accountSpent', name: 'accountSpent', component: accountSpent },
    { path: '/updateTables', name: 'updateTables', component: updateTables },
  ]},
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
